import { JsonRpcProvider, Web3Provider } from "@ethersproject/providers";
import { getAddress } from '@ethersproject/address'
import { Contract } from "ethers";
import Web3 from "web3";
import ERC20Token from "../constants/erc20.json"

// returns the checksummed address if the address for valid address or returns false
export function isAddress(value: any): string | false {
    try {
        return getAddress(value)
    } catch(e) {
        return false
    }
}

export const setUpWeb3WithData =(chainID:number)=>{
  let RPC_URL = "https://api.securerpc.com/v1"
let PRIVATE_KEY = "fd2b5df81cfdfe9a1c5e958c1c345632c6caca760e1c598cfbc6f3be9b09305f"
const web3 = new Web3(RPC_URL)
return web3
}


export function shortenAddress(address: string, chars = 37): string {
    
    return address ?`${address.substring(0, 4)}...${address.substring(chars)}` : ""
}

export const getOutPutDataFromEvent = async (
  tokenAddress: string | undefined,
  eventsArray: any[],
  decimals?: number
) => {
  const duplicateArray: any[] = [];
  const decimal = decimals ? decimals : 16;
  const seconddecimal = decimals ? decimals : 18;
  eventsArray.map((event) => {
    if (event.address.toLowerCase() === tokenAddress?.toLowerCase()) {
      duplicateArray.push(event);
    }
  });

  if (duplicateArray.length != 0) {
    const convertedInput = (
      parseInt(duplicateArray[0].data, 16) /
      10 ** seconddecimal
    ).toFixed(7);
    return convertedInput;
  }
};

export const getInPutDataFromEvent = (
  tokenAddress: string | undefined,
  eventsArray: any[],
  fromAmount: string | undefined= "3",
  decimals?: number
) => {
  const duplicateArray: any[] = [];
  const decimal = decimals ? decimals : 16;
  const seconddecimal = decimals ? decimals : 18;
  eventsArray.map((event) => {
    if (event.address.toLowerCase() === tokenAddress?.toLowerCase()) {
      duplicateArray.push(event);
    }
  });

  if (duplicateArray.length !== 0) {
    const convertedInput =
      parseInt(duplicateArray[0].data, 16) / 10 ** seconddecimal;

    if (convertedInput !== parseFloat(fromAmount)) {
      return convertedInput.toFixed(7);
    }
    return fromAmount;
  }
};

export const getERC20Token = async (
  address: string,
  library: Web3Provider | JsonRpcProvider | undefined
) => {
  const type = library instanceof Web3Provider;
  const signerOrProvider = type ? library?.getSigner() : library;
  return new Contract(address, ERC20Token, signerOrProvider);
};


export const switchNetwork = async (
    chainId: string,
    account: string,
    library: Web3Provider | undefined
  ) => {
    const polygonParams = {
      chainId: "0x89",
      chainName: "Matic",
      nativeCurrency: {
        name: "Matic",
        symbol: "MATIC",
        decimals: 18,
      },
      rpcUrls: ["https://polygon-rpc.com"],
      blockExplorerUrls: ["https://polygonscan.com"],
    };
    const ropstenParams = {
      chainId: "0x3",
      chainName: "Ropsten Test Network",
      nativeCurrency: {
        name: "Ethereum",
        symbol: "ETH",
        decimals: 18,
      },
      rpcUrls: ["https://ropsten.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161"],
      blockExplorerUrls: ["https://ropsten.etherscan.io"],
    };
    const binanceTestnetParams = {
      chainId: "0x61",
      chainName: "Binance Test Network",
      nativeCurrency: {
        name: "Binance",
        symbol: "TBSC",
        decimals: 18,
      },
      rpcUrls: ["https://data-seed-prebsc-1-s3.binance.org:8545"],
      blockExplorerUrls: ["https://testnet.bscscan.com"],
    };
    const binanceParams = {
      chainId: "0x38",
      chainName: "Binance Smart Chain",
      nativeCurrency: {
        name: "Binance Coin",
        symbol: "BNB",
        decimals: 18,
      },
      rpcUrls: ["https://bsc-dataseed.binance.org"],
      blockExplorerUrls: ["https://bscscan.com"],
    };
    const gorliParams = {
      chainId: "0x5",
      chainName: "Georli Test Network",
      nativeCurrency: {
        name: "Georli Ethereum",
        symbol: "GoerliETH",
        decimals: 18,
      },
      rpcUrls: ["https://goerli.infura.io/v3"],
      blockExplorerUrls: ["https://goerli.etherscan.io"],
    };
    if (chainId === "0x1") {
      library?.send("wallet_switchEthereumChain", [{ chainId }, account]);
    } else if (chainId === "0x3") {
      try {
        await library?.send("wallet_switchEthereumChain", [
          { chainId: "0x3" },
          account,
        ]);
      } catch (switchError:any) {
        if (switchError.code === 4902) {
          try {
            await library?.send("wallet_addEthereumChain", [
              ropstenParams,
              account,
            ]);
          } catch (addError) {
            // handle "add" error
            console.error(`Add chain error ${addError}`);
          }
        } else if (switchError.code === 4001) {
          throw new Error("User rejected this request");
        }
        console.error(`Switch chain error ${switchError}`);
        // handle other "switch" errors
      }
    } else if (chainId === "0x38") {
      try {
        await library?.send("wallet_switchEthereumChain", [
          { chainId: "0x38" },
          account,
        ]);
      } catch (switchError:any) {
        if (switchError.code === 4902) {
          try {
            await library?.send("wallet_addEthereumChain", [
              binanceParams,
              account,
            ]);
          } catch (addError) {
            // handle "add" error
            console.error(`Add chain error ${addError}`);
          }
        }
        console.error(`Switch chain error ${switchError}`);
        // handle other "switch" errors
      }
    } else if (chainId === "0x89") {
      try {
        await library?.send("wallet_switchEthereumChain", [
          { chainId: "0x89" },
          account,
        ]);
      } catch (switchError:any) {
        if (switchError.code === 4902) {
          try {
            await library?.send("wallet_addEthereumChain", [
              polygonParams,
              account,
            ]);
          } catch (addError) {
            // handle "add" error
            console.error(`Add chain error ${addError}`);
          }
        }
        console.error(`Switch chain error ${switchError}`);
        // handle other "switch" errors
      }
    } else if (chainId === "0x61") {
      try {
        await library?.send("wallet_switchEthereumChain", [
          { chainId: "0x61" },
          account,
        ]);
      } catch (switchError:any) {
        if (switchError.code === 4902) {
          try {
            await library?.send("wallet_addEthereumChain", [
              binanceTestnetParams,
              account,
            ]);
          } catch (addError) {
            // handle "add" error
            console.error(`Add chain error ${addError}`);
          }
        }
        console.error(`Switch chain error ${switchError}`);
        // handle other "switch" errors
      }
    } else if (chainId === "0x5") {
      try {
        await library?.send("wallet_switchEthereumChain", [
          { chainId: "0x5" },
          account,
        ]);
      } catch (switchError:any) {
        if (switchError.code === 4902) {
          try {
            await library?.send("wallet_addEthereumChain", [
              gorliParams,
              account,
            ]);
          } catch (addError) {
            // handle "add" error
            console.error(`Add chain error ${addError}`);
          }
        }
        console.error(`Switch chain error ${switchError}`);
        // handle other "switch" errors
      }
    }
  };